<script lang="ts">
  import ChevronDown from '$icons/ChevronDownIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';

  export let contentOpen = false;
  export let border = true;
  export let noPadding = false;
  export let preventDefault = false;

  const dispatch = createEventDispatcher();
</script>

<div class="border-blueish-grey-200 rounded-2xl" class:border class:p-4={!noPadding}>
  <button
    class="w-full flex flex-row justify-between cursor-pointer"
    on:click={() => {
      if (preventDefault) return;
      contentOpen = !contentOpen;
      dispatch('toggle', contentOpen);
    }}
    on:keydown
  >
    <slot {contentOpen} name="header">
      <div>
        <slot name="title">
          <span class="text-blueish-grey-900 font-bold"> Title here </span>
        </slot>
      </div>
      <button
        class="cursor-pointer ease-in-out duration-200 transform select-none"
        class:-rotate-180={!contentOpen}
        on:keydown
      >
        <ChevronDown />
      </button>
    </slot>
  </button>

  {#if contentOpen}
    <div transition:slide|global={{ duration: 100 }}>
      <slot />
    </div>
  {/if}
</div>
